import Typography from 'components/Typography';
import React, { useMemo } from 'react';

import { Container, Body } from './styles';

const PendenciesFieldItem = ({ step, items, title }) => {
  const formatStep = useMemo(() => {
    const variant = {
      1: '1. Dados cadastrais',
      2: '2. Testemunha',
      3: '3. Imagens, vídeos e presença digital',
    }

    return variant[step];
  }, [step]);

  return (
    <Container>
      {
        title ? (
          <Typography variant="body2" color="grayDark2">
            {title}
          </Typography>
        ) : (
          <>
            <Typography variant="body2" color="grayDark2">
              {formatStep}
            </Typography>
            <Body>
              {
                items.map(item => (
                  <Typography variant="manrope" color="brown" key={item}>
                    {item}
                  </Typography>
                ))
              }
            </Body>
          </>
        )
      }
      
    </Container>
  );
};

export default PendenciesFieldItem;